import Configuration from "front-component/Configuration";
import AbstractRepository from "@/repositories/AbstractRepository";
import Http from "front-component/Http";

export interface Document {
    uuid: string;
    link: string;
    clientOriginalFileName: string;
    type: string;
}

export default class FileRepository extends AbstractRepository {
    protected static resource: string = "document";

    public static getUploadUrl(): string {
        return Configuration.get("apiUri") + `/upload`;
    }

    public static download(documentDownloaded: Document): void {
        Http
            .download(
                documentDownloaded.link,
                [],
                (data: Blob) => {
                    const url = window.URL.createObjectURL(data);
                    const link = document.createElement("a");
                    link.href = url;
                    link.setAttribute("download", documentDownloaded.clientOriginalFileName);
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                },
                "errorDownloadDocument"
            )
        ;
    }
}
